import React from "react";
import PropTypes from "prop-types";

import useCurrentUser from "data/advisor/useCurrentUser";

import {
  useBillingForm,
  useErrorHandler,
  useOnboardingStepsData,
  useSubscriptionService,
} from "./hooks";
import { BillingAddress, Button, Form, PaymentInformation } from "./components";

export function SubscriptionCreator({ plan, onCreated }) {
  const user = useCurrentUser();
  const { formProps, setError } = useBillingForm(user);
  const handleError = useErrorHandler(setError);
  const s = useSubscriptionService(onCreated, handleError);
  const { store } = useOnboardingStepsData();

  const handleSubmit = (v) => {
    s.createAccount({
      plan: plan,
      company: store?.profile?.firmName || "",
      coupons: store?.subscription?.coupons,
      ...v,
    });
  };

  return (
    <Form {...formProps} onSubmit={handleSubmit}>
      <PaymentInformation disabled={s.submitting} ref={s.cbInstanceRef} />
      <BillingAddress disabled={s.submitting} />
      <Button
        primary
        fluid
        type="submit"
        loading={s.submitting}
        disabled={s.submitting}
      >
        Start your free trial
      </Button>
    </Form>
  );
}

SubscriptionCreator.propTypes = {
  plan: PropTypes.string.isRequired,
  onCreated: PropTypes.func.isRequired,
};

export default SubscriptionCreator;
